import { RelatedAsset } from '@app/core/model/entities/asset/asset';

export interface AssetsRelatedEntity {
  /**
   * Get all related assets inside the Entity computed properties.
   * @return List of related assets
   */
  relatedAssets: RelatedAsset[];
}

/**
 * Type guard to check if an object is an instance of AssetsRelatedEntity.
 * Ensures type safety by verifying that the required relatedAssets property exists.
 * TypeScript does not allow direct casting when properties do not overlap between types.
 * @param obj The object to check.
 * @return true if obj is an AssetsRelatedEntity, otherwise false.
 */
export function isAssetRelatedEntity(obj: any): obj is AssetsRelatedEntity {
  return obj && 'relatedAssets' in obj;
}
